import { Component, OnInit, Inject, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar, MatDialog, getMatFormFieldDuplicatedHintError } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service';
import { ServerService } from '../../../services/server.service';
import { DatePipe } from '@angular/common';
import { ClipBoardService as messageService} from 'src/app/services/clipboard.service';
@Component({
  selector: 'app-add-budget',
  templateUrl: './add-budget.component.html',
  styleUrls: ['./add-budget.component.scss'],
  providers: [DatePipe]
})
export class AddBudgetComponent implements OnInit {

  authToken = localStorage.getItem("token");

  showComponentLoader: boolean = false;

  btnStatus: boolean = false

  isUpdate: boolean = false;

  createdAt: any = ""

  myDateRangePickerOptions = {
    dateFormat: 'dd.mm.yyyy'
  };

  platformList: any = []
  adTypeList: any = []

  addForm: FormGroup;

  //xx:any = [];

  headerStats:any;

  currentDate:any = new Date();

  additionalBudget:boolean = false;

  mmList: any;

  constructor(
    private serverService: ServerService,
    private clipBoardService: ClipBoardService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private changeDetectorRef: ChangeDetectorRef,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<AddBudgetComponent>,
    private clipBoardMessageService:messageService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
  }

  ngOnInit() {
    this.getDropDown()
    this.setDeliveryForm()
    this.getMM()
    this.getSpentBudgetDeliveryStats()

    //this.xx = this.counter(4);

    //console.log(this.xx)
  }
  getNum(spent:any,lead:any):any{
    let s = this.removeCommas(spent)
    let d = this.removeCommas(lead)
    return (Number(s)/Number(d)).toFixed(2)
  }
  removeCommas(value: any): string {
    if (!value) return "0";
    return typeof value === "string"
      ? value.replace(/,/g, "")
      : value.toString();
  }
  // counter(i: number){
  //   return new Array(i);
  // }

  getSpentBudgetDeliveryStats() {

    this.showComponentLoader = true;

    let url = "campaign_module/campaign/spent_budget_delivery_stats/"+this.data.id;

    this.serverService.getSpentBudgetDeliveryStats(url, this.authToken).subscribe(data => {
      //console.log(data)
      this.headerStats = data.stats[data.stats.length-1];
      //console.log(this.headerStats)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  getDropDown() {

    this.showComponentLoader = true;

    let url = "campaign_module/get_common_details";

    this.serverService.getLeadDeliveryDropDown(url, this.authToken).subscribe(data => {
      //console.log(data)
      this.platformList = data.platform_ad_type_list
      //console.log(this.platformList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  getAddType(event: any, i:any) {

    this.adTypeList[i] = []

    for (let item of this.platformList) {
      if (item.platform == event.value) {
        //console.log(item.ad_type)
        this.adTypeList[i] = item.ad_type
      }
    }

  }

  getMM() {

    this.showComponentLoader = true

    let url = "/campaign_module/user_list?user_type=OrgAdmin";
    this.serverService.getMM(url, this.authToken).subscribe(data => {
      this.mmList = data.data
      //console.log(this.mmList)
      this.showComponentLoader = false
    },
      err => {
        this.showComponentLoader = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )

  }

  getBudgetType(event:any, i:any){

    const control:any = this.arrAddDeliveryForm.at(i).get('additional_budget');

    if(event.value == 'Addition'){
      control.enable();
    } else if(event.value == 'Deduction'){
      control.disable();
    }
  }

  setDeliveryForm() {
    this.addForm = this.fb.group({
      addInnerForm: this.fb.array([this.setAddDeliveryForm()])
    })
  }

  setAddDeliveryForm() {
    return this.fb.group({
      recorded_date: ['', Validators.compose([Validators.required])],
      budget_type: ['', Validators.compose([Validators.required])],
      platform: ['', Validators.compose([Validators.required])],
      marketing_manager_id: [, Validators.compose([Validators.required])],
      amount: [null, Validators.compose([Validators.required])],
      total_lead: [null, Validators.compose([Validators.required])],
      additional_budget: [{value: false, disabled: false}, Validators.compose([Validators.required])],
      remarks: [''],
    })
  }

  get arrAddDeliveryForm(): FormArray {
    return this.addForm.get("addInnerForm") as FormArray;
  }

  addRow() {
    this.arrAddDeliveryForm.push(this.setAddDeliveryForm());
  }

  removeRow(i) {
    if (this.arrAddDeliveryForm.length > 1) {
      this.arrAddDeliveryForm.removeAt(i);
    }
  }

  saveDeliveryForm() {   
    
    this.btnStatus = true;

    this.addForm.value.addInnerForm.forEach((e:any)=>{
      // ...e,
      // remarks: e.remarks==''?null:e.remarks
      if (e.remarks === "") {
        delete e.remarks;
    }
    })   

    let body = {
      campaign_id: this.data.id,
      records: this.addForm.value.addInnerForm
    }

    this.serverService.saveBudgetForm('campaign_module/campaign/add_budget_allocation', body, this.authToken).subscribe(data => {
      this.clipBoardMessageService.showMessgeInText("Credit Added Successfully", "success-snackbar")
      this.btnStatus = false
      this.dialogRef.close(data)
    },
      err => {
        this.btnStatus = false
        this.clipBoardService.checkServerError(err, this.authToken)
      }
    )
  }

  close() {
    this.dialogRef.close();
  }

  onKeyPress(event: KeyboardEvent) {
    const allowedCharacters = /^[0-9+\.]+$/;
    const inputChar = String.fromCharCode(event.keyCode);

    if (!allowedCharacters.test(inputChar)) {
      event.preventDefault();
    }
  }
  userType(item) {
    return item.org_admin && !item.role
      ? 'Vendor Admin'
      : !item.org_admin && !item.role
      ? 'Vendor Standard User'
      : item.role;
  }
}